// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Restaumatic_Form_Internal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic_Form_Query from "../Restaumatic.Form.Query/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Host.bindHost);
var pure = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Host.applicativeHost);
var dumpState_Record = /* #__PURE__ */ Restaumatic_Form_Internal.dumpState_Record();
var dumpStateRecordCons = /* #__PURE__ */ Restaumatic_Form_Internal.dumpStateRecordCons({
    reflectSymbol: function () {
        return "extra";
    }
});
var dumpStateRecordCons1 = /* #__PURE__ */ Restaumatic_Form_Internal.dumpStateRecordCons({
    reflectSymbol: function () {
        return "subform";
    }
})(Restaumatic_Form_Internal.dumpStateRecordNil);
var WithExtraInitializer = /* #__PURE__ */ (function () {
    function WithExtraInitializer(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    WithExtraInitializer.create = function (value0) {
        return function (value1) {
            return new WithExtraInitializer(value0, value1);
        };
    };
    return WithExtraInitializer;
})();
var WithExtra = function (x) {
    return x;
};
var isTextFieldWithExtra = function (dictIsTextField) {
    var textInput = Restaumatic_Form_Internal.textInput(dictIsTextField);
    return {
        textInput: function (v) {
            return textInput(v.subform);
        }
    };
};
var initializeWithExtraInitia = function (dictInitialize) {
    var makeImpl = Restaumatic_Form_Internal.makeImpl(dictInitialize);
    return function (dictInitialize1) {
        var makeImpl1 = Restaumatic_Form_Internal.makeImpl(dictInitialize1);
        return {
            makeImpl: function (p) {
                return function (opts) {
                    return function (meta) {
                        return function (iv) {
                            return function (v) {
                                return bind(makeImpl(p)(opts)(meta)(iv)(v.value0))(function (subform_) {
                                    return bind(makeImpl1(p)(opts)(meta)(Restaumatic_Form_Internal.NoInitialValue.value)(v.value1))(function (extra_) {
                                        return pure({
                                            subform: subform_,
                                            extra: extra_
                                        });
                                    });
                                });
                            };
                        };
                    };
                };
            }
        };
    };
};
var initializeMetadataInitial = function (dictMakeWithMetadataInitializer) {
    return {
        makeImpl: Restaumatic_Form_Internal.makeWithMetadataInitializer(dictMakeWithMetadataInitializer)
    };
};
var hasFieldWithExtraTrue = function () {
    return function (dictIsSymbol) {
        var getField = Data_Record.getField(Data_Record.hasFieldRecord(dictIsSymbol)());
        return {
            getFieldWithExtra: function (label) {
                return function (v) {
                    return function (v1) {
                        return getField(label)(v1.extra);
                    };
                };
            }
        };
    };
};
var hasFieldWithExtraFalse = function (dictHasField) {
    var getField = Data_Record.getField(dictHasField);
    return {
        getFieldWithExtra: function (label) {
            return function (v) {
                return function (v1) {
                    return getField(label)(v1.subform);
                };
            };
        }
    };
};
var dumpStateWithExtra = function (dictDumpState) {
    var dumpStateRecordCons2 = dumpStateRecordCons(dumpStateRecordCons1(dictDumpState)()());
    return function (dictDumpState1) {
        var dumpState = Restaumatic_Form_Internal.dumpState(dumpState_Record(dumpStateRecordCons2(dictDumpState1)()()));
        return {
            dumpState: function (v) {
                return dumpState(v);
            }
        };
    };
};
var addErrorsWithExtra = function (dictAddErrors) {
    var addErrors = Restaumatic_Form_Internal.addErrors(dictAddErrors);
    return function (dictAddErrors1) {
        var addErrors1 = Restaumatic_Form_Internal.addErrors(dictAddErrors1);
        return {
            addErrors: function (errors) {
                return function (v) {
                    return function __do() {
                        addErrors(errors)(v.subform)();
                        return addErrors1(errors)(v.extra)();
                    };
                };
            }
        };
    };
};
var addContextWithExtra = function (dictAddContext) {
    var addContext = Restaumatic_Form_Internal.addContext(dictAddContext);
    return function (dictAddContext1) {
        var addContext1 = Restaumatic_Form_Internal.addContext(dictAddContext1);
        return {
            addContext: function (ctx) {
                return function (v) {
                    return function __do() {
                        addContext(ctx)(v.subform)();
                        return addContext1(ctx)(v.extra)();
                    };
                };
            }
        };
    };
};
var withExtra = /* #__PURE__ */ (function () {
    return WithExtraInitializer.create;
})();
var subform = function (v) {
    return v.subform;
};
var hasErrorsWithExtra = function (dictHasErrors) {
    var displayedErrors = Restaumatic_Form_Internal.displayedErrors(dictHasErrors);
    return {
        displayedErrors: function (f) {
            return displayedErrors(subform(f));
        }
    };
};
var hasFieldIdWithExtra = function (dictHasFieldId) {
    return {
        getFieldId: (function () {
            var $109 = Restaumatic_Form_Internal.getFieldId(dictHasFieldId);
            return function ($110) {
                return $109(subform($110));
            };
        })()
    };
};
var hasLabelWithExtra = function (dictHasLabel) {
    var getLabel = Restaumatic_Form_Internal.getLabel(dictHasLabel);
    return {
        getLabel: function (f) {
            return getLabel(subform(f));
        }
    };
};
var isSelectFieldWithExtra = function (dictIsSelectField) {
    var selectWriteValue = Restaumatic_Form_Internal.selectWriteValue(dictIsSelectField);
    var selectReadValue = Restaumatic_Form_Internal.selectReadValue(dictIsSelectField);
    var selectGetOptions = Restaumatic_Form_Internal.selectGetOptions(dictIsSelectField);
    var selectTouch = Restaumatic_Form_Internal.selectTouch(dictIsSelectField);
    return {
        selectWriteValue: function (f) {
            return selectWriteValue(subform(f));
        },
        selectReadValue: function (f) {
            return selectReadValue(subform(f));
        },
        selectGetOptions: function (f) {
            return selectGetOptions(subform(f));
        },
        selectTouch: function (f) {
            return selectTouch(subform(f));
        }
    };
};
var mergeWithExtra = function (dictMerge) {
    var merge = Restaumatic_Form_Internal.merge(dictMerge);
    return {
        merge: function (d) {
            var $111 = merge(d);
            return function ($112) {
                return $111(subform($112));
            };
        }
    };
};
var queryWithExtra = function (dictQuery) {
    var queryImpl = Restaumatic_Form_Query.queryImpl(dictQuery);
    return {
        queryImpl: function (s) {
            var $113 = queryImpl(s);
            return function ($114) {
                return $113(subform($114));
            };
        }
    };
};
var getFieldWithExtra = function (dict) {
    return dict.getFieldWithExtra;
};
var hasFieldWithExtraRecord = function () {
    return function (dictHasFieldWithExtra) {
        var getFieldWithExtra1 = getFieldWithExtra(dictHasFieldWithExtra);
        return {
            getField: function (label) {
                return getFieldWithExtra1(label)(Type_Proxy["Proxy"].value);
            }
        };
    };
};
var extra = function (v) {
    return v.extra;
};
export {
    getFieldWithExtra,
    WithExtra,
    WithExtraInitializer,
    withExtra,
    subform,
    extra,
    hasFieldWithExtraRecord,
    hasFieldWithExtraTrue,
    hasFieldWithExtraFalse,
    initializeWithExtraInitia,
    initializeMetadataInitial,
    queryWithExtra,
    mergeWithExtra,
    addContextWithExtra,
    dumpStateWithExtra,
    addErrorsWithExtra,
    isSelectFieldWithExtra,
    hasLabelWithExtra,
    hasErrorsWithExtra,
    isTextFieldWithExtra,
    hasFieldIdWithExtra
};
